import { combineReducers } from "redux";
import { rulesSelectedFacilityReducer } from "./rules_selected_facility_reducer";
import { rulesSelectedOrganizationReducer } from "./rules_selected_organization_reducer";

export const rulesSelectedOptionsReducer = combineReducers({
  organizationId: rulesSelectedOrganizationReducer,
  facilityId: rulesSelectedFacilityReducer
});
